<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()"
        v-if="convenio.idSituacaoConvenio != 9">
            Adicionar
        </b-button>
        <aditivo-form
            operacaoProp="I"
            :convenio="convenio"
            :aditivo="aditivo"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></aditivo-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AditivoForm from './AditivoForm'

export default {
    components: {
        AditivoForm
    },

    props: {
        convenio: Object,
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            aditivo: {
                idConvenio:0,
                dataAditivo: null,
                dataProrrogada: null,
                objeto:'',
                tipoAditivo:1,
                valorAditivo:0,
                statusAditivo:1,
            },
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(aditivo){
            this.$store.dispatch('addRequest')
            let aditivoDto = {
                idConvenio : this.$route.params.convenioId,
                dataAditivo: new Date(),
                objeto: aditivo.objeto,
                tipoAditivo: aditivo.tipoAditivo,
                dataProrrogada: aditivo.tipoAditivo == 1 ? this.$moment(aditivo.dataProrrogada, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                valorAditivo : aditivo.valorAditivo,
                statusAditivo: aditivo.statusAditivo,
            }
            ConveniosServicos.inserirAditivo(aditivoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Aditivo inserido com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
